import { useCallback } from 'react';

export const useDownloadFile = () => {
  const downloadFile = useCallback((url: string) => {
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }, []);

  return downloadFile;
};
